// prettier-ignore
const lessBarsIcon = () => <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 13C0 12.4477 0.447715 12 1 12H6C6.55228 12 7 12.4477 7 13V30C7 30.5523 6.55228 31 6 31H1C0.447715 31 0 30.5523 0 30V13Z" fill="#3FD08F"/>
<path d="M9 1C9 0.447716 9.44772 0 10 0H15C15.5523 0 16 0.447715 16 1V30C16 30.5523 15.5523 31 15 31H10C9.44772 31 9 30.5523 9 30V1Z" fill="#3FD08F"/>
<path d="M18 6C18 5.44772 18.4477 5 19 5H24C24.5523 5 25 5.44772 25 6V30C25 30.5523 24.5523 31 24 31H19C18.4477 31 18 30.5523 18 30V6Z" fill="#3FD08F"/>
<path d="M27 11C27 10.4477 27.4477 10 28 10H33C33.5523 10 34 10.4477 34 11V30C34 30.5523 33.5523 31 33 31H28C27.4477 31 27 30.5523 27 30V11Z" fill="#3FD08F"/>
</svg>

export default lessBarsIcon;
